export default __webpack_public_path__ + "static/media/suppliers and me.00dea578.png";